import { Component, Input, Output, EventEmitter, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ButtonForm } from '../../button-form/button-form';
import { OngetSideBar } from '../../onget-side-bar/onget-side-bar';
import { Modal } from '../../modal/modal';
import { AuthService } from '../../../core/services/auth/auth-service';

@Component({
  selector: 'app-sidebar-coach',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonForm, OngetSideBar, Modal],
  templateUrl: './sidebar-coach.html',
  styleUrl: './sidebar-coach.css',
})
export class SidebarCoach {
  showModal = signal<boolean>(false);

  @Input() isOpen = false;
  @Output() toggleSidebar = new EventEmitter<void>();
  private authService = inject(AuthService);
  private breakpointObserver = inject(BreakpointObserver);

  mainMenu = [
    { label: 'Tableau de bord', icon: 'home', route: '/coach/dashboard' },
    { label: 'Mes Formules', icon: 'package', route: '/coach/packages' },
    { label: 'Mes Clients', icon: 'users', route: '/coach/customers' },
  ];

  toggleModal() {
    this.showModal.set(!this.showModal());
  }

  onItemClick() {
    if (this.breakpointObserver.isMatched([Breakpoints.Handset, '(max-width: 1023.98px)'])) {
      this.toggleSidebar.emit();
    }
  }

  onLogout() {
    this.authService.logout();
  }
}
